import { AssessmentState } from "./types";

const state: AssessmentState = { language: null };

export default state;
